import React from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import BlockRenderer from "./BlockRenderer";
import { BLOCK_TYPE_OPTIONS, BUTTON_TARGET_OPTIONS } from "./BlockToolbar";
import { HEADING_LEVELS } from "../articleApi";
import { applyTableFormat } from "./TableControl";

const stop = (event) => event.stopPropagation();

const BlockOptionSelect = ({ value, onChange, children, title }) => (
  <select
    title={title}
    className="gutenberg-block__option"
    value={value}
    onClick={stop}
    onChange={(event) => {
      stop(event);
      onChange(event.target.value);
    }}
  >
    {children}
  </select>
);

const BlockCanvas = ({
  form,
  blocks,
  blockErrors = {},
  selectedBlockId,
  articleId,
  onSelectBlock,
  onUpdateForm,
  onUpdateBlock,
  onUpdateBlockType,
  onAddBlock,
  onMoveBlock,
  onDuplicateBlock,
  onRemoveBlock,
}) => (
  <div className="gutenberg-canvas">
    <input
      className="gutenberg-canvas__title"
      value={form.title}
      placeholder="Add title"
      onChange={(event) => onUpdateForm("title", event.target.value)}
    />

    <textarea
      className="gutenberg-canvas__excerpt"
      value={form.excerpt}
      placeholder="Write a short excerpt..."
      rows={3}
      onChange={(event) => onUpdateForm("excerpt", event.target.value)}
    />

    <div className="gutenberg-blocks">
      {blocks.map((block, index) => {
        const blockError = blockErrors[block.id];
        return (
        <div
          key={block.id}
          data-block-id={block.id}
          className={`gutenberg-block ${selectedBlockId === block.id ? "is-selected" : ""} ${blockError ? "is-error" : ""}`}
          onClick={() => onSelectBlock(block.id)}
        >
          <div className="gutenberg-block__toolbar">
            <div className="gutenberg-block__settings">
              <BlockOptionSelect
                title="Block type"
                value={block.type}
                onChange={(type) => onUpdateBlockType(block.id, type)}
              >
                {BLOCK_TYPE_OPTIONS.map((option) => (
                  <option key={option.type} value={option.type}>
                    {option.label}
                  </option>
                ))}
              </BlockOptionSelect>

              {block.type === "heading" && (
                <BlockOptionSelect
                  title="Heading level"
                  value={block.data?.level || "h2"}
                  onChange={(level) => onUpdateBlock(block.id, { level })}
                >
                  {HEADING_LEVELS.map((level) => (
                    <option key={level} value={level}>
                      {level.toUpperCase()}
                    </option>
                  ))}
                </BlockOptionSelect>
              )}

              {block.type === "button" && (
                <BlockOptionSelect
                  title="Link target"
                  value={block.data?.target || "_self"}
                  onChange={(target) => onUpdateBlock(block.id, { target })}
                >
                  {BUTTON_TARGET_OPTIONS.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </BlockOptionSelect>
              )}

              {block.type === "table" && (
                <>
                  <button
                    type="button"
                    className="gutenberg-block__format"
                    title="Bold"
                    onMouseDown={(event) => {
                      event.preventDefault();
                      stop(event);
                    }}
                    onClick={(event) => {
                      stop(event);
                      applyTableFormat(block.id, "strong");
                    }}
                  >
                    <Icon icon="ph:text-b-bold" height={14} />
                  </button>
                  <button
                    type="button"
                    className="gutenberg-block__format"
                    title="Italic"
                    onMouseDown={(event) => {
                      event.preventDefault();
                      stop(event);
                    }}
                    onClick={(event) => {
                      stop(event);
                      applyTableFormat(block.id, "em");
                    }}
                  >
                    <Icon icon="ph:text-italic" height={14} />
                  </button>
                </>
              )}
            </div>

            <div className="gutenberg-block__controls">
            <button
              type="button"
              title="Move up"
              onClick={(event) => {
                event.stopPropagation();
                onMoveBlock(block.id, -1);
              }}
            >
              <Icon icon="ph:arrow-up" height={14} />
            </button>
            <button
              type="button"
              title="Move down"
              onClick={(event) => {
                event.stopPropagation();
                onMoveBlock(block.id, 1);
              }}
            >
              <Icon icon="ph:arrow-down" height={14} />
            </button>
            <button
              type="button"
              title="Duplicate"
              onClick={(event) => {
                event.stopPropagation();
                onDuplicateBlock(block.id);
              }}
            >
              <Icon icon="ph:copy" height={14} />
            </button>
            <button
              type="button"
              title="Remove"
              onClick={(event) => {
                event.stopPropagation();
                onRemoveBlock(block.id);
              }}
            >
              <Icon icon="ph:trash" height={14} />
            </button>
            </div>
          </div>

          {blockError && <div className="gutenberg-block__error">{blockError}</div>}

          <BlockRenderer
            block={block}
            articleId={articleId}
            showBlockOptions={false}
            onUpdate={(nextData) => onUpdateBlock(block.id, nextData)}
          />

          <button
            type="button"
            className="gutenberg-block__add"
            onClick={(event) => {
              event.stopPropagation();
              onAddBlock("paragraph", index);
            }}
          >
            <Icon icon="ph:plus" height={14} />
          </button>
        </div>
        );
      })}
    </div>
  </div>
);

export default BlockCanvas;
